import { useCallback, useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SearchIcon } from '@chakra-ui/icons';
import { Box, Flex, Input, InputGroup, InputLeftElement, Text } from '@chakra-ui/react';
import { Action, Page } from '@/../../server/types/loggingTypes';
import HomeTabSuggestions from '@/components/Search/HomeTabSuggestions';
import { getStatsigClient } from '@/utils/statsig';

export const Route = createFileRoute('/_privateRoutes/_mainNavBar/')({
  component: Search,
});

export default function Search() {
  const navigate = useNavigate({ from: '/' });

  useEffect(() => {
    getStatsigClient().logEvent(Page.SEARCH_TAB, Action.VIEW);
  }, []);

  const handleFocus = useCallback(() => {
    navigate({ to: '/ask-your-friends' });
  }, []);

  return (
    <Box width="100%" overflowX="hidden" mt={10}>
      <Flex
        direction="column"
        alignItems="center"
        gap={4}
        mb="100px"
        width="100%"
        maxW="100%"
        mx="auto"
        overflowY="auto"
        overflowX="hidden"
        flex="1"
      >
        {/* Question input section */}
        <Flex direction="column" width="100%" gap={4}>
          <Text fontSize="2xl" fontWeight="bold" color="white" textAlign="center" px={6}>
            What do you need?
          </Text>
          <div className="px-4">
            <InputGroup>
              <InputLeftElement pointerEvents="none" height="100%" children={<SearchIcon color="gray.400" />} />
              <Input
                placeholder="Ask anything..."
                fontSize={{ base: 'md', md: 'md', lg: 'lg' }}
                fontWeight="bold"
                height={{ base: '56px', md: '58px', lg: '60px' }}
                bg="white"
                color="black"
                _placeholder={{ color: 'gray.400' }}
                borderRadius="full"
                paddingLeft="40px"
                onFocus={handleFocus}
                _focus={{
                  outline: 'none',
                  boxShadow: 'none',
                  borderColor: 'white',
                }}
              />
            </InputGroup>
          </div>
        </Flex>
        <hr className="w-full" style={{ borderColor: '#4e4e4e', marginTop: '8px', marginBottom: '24px' }} />
        <HomeTabSuggestions />
      </Flex>
    </Box>
  );
}
